// import * as React from 'react';
import {
  Archive,
  Clipboard,
  Download,
  Folder,
  Grid,
  Home,
  Layers,
  Settings,
  Trello,
  Database,
  UploadCloud,
  UserPlus,
  // UserPlus,
  Users,
} from 'react-feather';
import { NavItem } from '../components/shared/Sidebar';
import { isOrganisationAdmin } from '../services/reportingRequirements/planAccess';
import { hasGrantsPlan } from '../services/grants/planAccess';
import { DATA_TOOLS_BASE_PATH, DATA_TOOLS_SECTIONS } from '../containers/admin/dataTools/sections';

const hasCaseManagementRole = (user: any) => {
  const activeOrganisationRole = user?.userOrganisation?.role;
  return (
    activeOrganisationRole === 'CASE_MANAGEMENT_PRACTITIONER' ||
    activeOrganisationRole === 'CASE_MANAGEMENT_ADMINISTRATOR'
  );
};

export const FUNDER_NAV_ITEMS = (): NavItem[] => {
  const navItems = [
    {
      to: '/funder',
      title: 'Dashboard',
      icon: <Home size={20} color="white" className="sidebar-menu-icon" />,
    },
    {
      to: '/funder/reports',
      title: 'Reports',
      icon: <Folder size={20} color="white" className="sidebar-menu-icon" />,
    },
    {
      to: '/funder/programmes',
      title: 'Programmes',
      icon: <Layers size={20} color="white" className="sidebar-menu-icon" />,
    },
    {
      to: '/funder/manage',
      title: 'Manage',
      icon: <Settings size={20} color="white" className="sidebar-menu-icon" />,
      subMenu: [
        {
          to: '/funder/manage/institutions',
          title: 'Institutions',
        },
        {
          to: '/funder/manage/people',
          title: 'People',
        },
        {
          to: '/funder/manage/activities',
          title: 'Activities',
        },
        {
          to: '/funder/manage/workspaces',
          title: 'Forms',
        },
        {
          to: '/funder/manage/indicatorFrameworks',
          title: 'Indicators',
        },
        {
          // IB-1897: Premium, Business and Enterprise; shown with the diamond on other plans
          to: '/funder/manage/grants',
          title: 'Grants',
          locked: (user: any) => !hasGrantsPlan(user && user.plan),
        },
        {
          to: '/funder/manage/reporting-requirements',
          title: 'Reporting',
          check: (user: any) => isOrganisationAdmin(user?.userOrganisation?.role),
        },
      ],
    },
    {
      to: '/funder/manage/cases',
      title: 'My Cases',
      icon: <Clipboard size={20} color="white" className="sidebar-menu-icon" />,
      check: (user: any, hasCaseManagement: boolean) => {
        return hasCaseManagementRole(user);
      },
    },
    {
      to: '/funder/my-activities',
      title: 'My Activities',
      icon: <Trello size={20} color="white" className="sidebar-menu-icon" />,
    },
    {
      to: '/funder/my-forms',
      title: 'My Forms',
      icon: <Archive size={20} color="white" className="sidebar-menu-icon" />,
    },
    {
      to: '/funder/exports',
      title: 'Data Export',
      icon: <Download size={20} color="white" className="sidebar-menu-icon" />,
      hideItemIfModuleChecked: true,
      activePathPrefix: '/funder/exports',
    },
    {
      to: '/funder/admin',
      title: 'Admin',
      icon: <Grid size={20} color="white" className="sidebar-menu-icon" />,
    },
  ];
  return navItems;
};

export const INSTITUTION_NAV_ITEMS = (): NavItem[] => {
  const navItems = [
    {
      to: '/institution',
      title: 'Dashboard',
      icon: <Home size={20} color="white" className="sidebar-menu-icon" />,
    },
    {
      to: '/institution/reports',
      title: 'Reports',
      icon: <Folder size={20} color="white" className="sidebar-menu-icon" />,
    },
    {
      to: '/institution/programmes',
      title: 'Programmes',
      icon: <Layers size={20} color="white" className="sidebar-menu-icon" />,
    },
    {
      to: '/institution/manage',
      title: 'Manage',
      icon: <Settings size={20} color="white" className="sidebar-menu-icon" />,
      subMenu: [
        {
          to: '/institution/manage/institutions',
          title: 'Institutions',
        },
        {
          to: '/institution/manage/people',
          title: 'People',
        },
        {
          to: '/institution/manage/activities',
          title: 'Activities',
        },
        {
          to: '/institution/manage/workspaces',
          title: 'Forms',
        },
        {
          to: '/institution/manage/indicatorFrameworks',
          title: 'Indicators',
        },
        {
          to: '/institution/manage/reporting-requirements',
          title: 'Reporting',
          check: (user: any) => isOrganisationAdmin(user?.userOrganisation?.role),
        },
      ],
    },
    {
      to: '/institution/manage/cases',
      title: 'My Cases',
      icon: <Clipboard size={20} color="white" className="sidebar-menu-icon" />,
      check: (user: any, hasCaseManagement: boolean) => {
        return hasCaseManagementRole(user);
      },
    },
    {
      to: '/institution/my-activities',
      title: 'My Activities',
      icon: <Trello size={20} color="white" className="sidebar-menu-icon" />,
    },
    {
      to: '/institution/my-forms',
      title: 'My Forms',
      icon: <Archive size={20} color="white" className="sidebar-menu-icon" />,
    },
    {
      to: '/institution/exports',
      title: 'Data Export',
      icon: <Download size={20} color="white" className="sidebar-menu-icon" />,
      hideItemIfModuleChecked: true,
      activePathPrefix: '/institution/exports',
    },
    {
      to: '/institution/admin',
      title: 'Admin',
      icon: <Grid size={20} color="white" className="sidebar-menu-icon" />,
    },
  ];
  return navItems;
};

export const SP_NAV_ITEMS = (): NavItem[] => {
  const navItems = [
    {
      to: '/service-provider',
      title: 'Dashboard',
      icon: <Home size={20} color="white" className="sidebar-menu-icon" />,
    },
    {
      to: '/service-provider/reports',
      title: 'Reports',
      icon: <Folder size={20} color="white" className="sidebar-menu-icon" />,
    },
    {
      to: '/service-provider/programmes',
      title: 'Programmes',
      icon: <Layers size={20} color="white" className="sidebar-menu-icon" />,
    },
    {
      to: '/service-provider/manage',
      title: 'Manage',
      icon: <Settings size={20} color="white" className="sidebar-menu-icon" />,
      subMenu: [
        {
          to: '/service-provider/manage/institutions',
          title: 'Institutions',
        },
        {
          to: '/service-provider/manage/people',
          title: 'People',
        },
        {
          to: '/service-provider/manage/activities',
          title: 'Activities',
        },
        {
          to: '/service-provider/manage/workspaces',
          title: 'Forms',
        },
        {
          to: '/service-provider/manage/indicatorFrameworks',
          title: 'Indicators',
        },
        {
          to: '/service-provider/manage/reporting-requirements',
          title: 'Reporting',
          check: (user: any) => isOrganisationAdmin(user?.userOrganisation?.role),
        },
      ],
    },
    {
      to: '/service-provider/manage/cases',
      title: 'My Cases',
      icon: <Clipboard size={20} color="white" className="sidebar-menu-icon" />,
      check: (user: any, hasCaseManagement: boolean) => {
        return hasCaseManagementRole(user);
      },
    },
    {
      to: '/service-provider/my-activities',
      title: 'My Activities',
      icon: <Trello size={20} color="white" className="sidebar-menu-icon" />,
    },
    {
      to: '/service-provider/my-forms',
      title: 'My Forms',
      icon: <Archive size={20} color="white" className="sidebar-menu-icon" />,
    },
    {
      to: `/team-activities`,
      title: 'Team & Activities',
      icon: <Users size={20} color="white" className="sidebar-menu-icon" />,
    },
    {
      to: '/service-provider/exports',
      title: 'Data Export',
      icon: <Download size={20} color="white" className="sidebar-menu-icon" />,
      hideItemIfModuleChecked: true,
      activePathPrefix: '/service-provider/exports',
    },
    {
      to: '/service-provider/admin',
      title: 'Admin',
      icon: <Grid size={20} color="white" className="sidebar-menu-icon" />,
    },
  ];
  return navItems;
};

export const ADMIN_NAV_ITEMS: NavItem[] = [
  {
    to: '/admin',
    title: 'Dashboard',
    icon: <Home size={20} color="white" className="sidebar-menu-icon" />,
  },
  {
    to: '/admin/manage',
    title: 'Manage',
    icon: <Settings size={20} color="white" className="sidebar-menu-icon" />,
    subMenu: [
      {
        to: '/admin/funders',
        title: 'Funders',
      },
      {
        to: '/admin/interventions',
        title: 'Interventions',
      },
      {
        to: '/admin/institutions',
        title: 'Institutions',
      },
      {
        to: '/admin/manage/insights',
        title: 'Insights',
      },
      {
        to: '/admin/programmes',
        title: 'Programmes',
      },
      {
        to: '/admin/service-providers',
        title: 'Service Providers',
      },
      {
        to: '/admin/manage/people',
        title: 'People',
      },
      {
        to: '/admin/team-members',
        title: 'Team Members',
      },
      {
        to: '/admin/templates',
        title: 'Forms',
      },
      {
        to: '/admin/declarations',
        title: 'Declarations',
      },
      {
        to: '/admin/auditTrail',
        title: 'Audit Trail',
      },
    ],
  },
  {
    to: '/admin/data-upload',
    title: 'Data Upload',
    icon: <UploadCloud size={20} color="white" className="sidebar-menu-icon" />,
    subMenu: [
      {
        to: '/admin/school-enrolment-data',
        title: 'School Enrolment',
      },
      {
        to: '/admin/school-attendance-data',
        title: 'Learner Attendance',
      },
      {
        to: '/admin/school-educators',
        title: 'Educator Attendance',
      },

      {
        to: '/admin/test-performance',
        title: 'Exam/Test Results',
      },
      {
        to: '/admin/school-subject-report',
        title: 'Report Results',
      },
      {
        to: '/admin/school-promotion-data',
        title: 'School Promotion',
      },
      {
        to: '/admin/nsc-progression',
        title: 'NSC Progression',
      },
      {
        to: '/admin/nsc-subjects',
        title: 'NSC Subject Results',
      },
    ],
  },
  {
    to: '/admin/data-tools',
    title: 'Data Tools',
    icon: <Database size={20} color="white" className="sidebar-menu-icon" />,
    subMenu: [
      { to: DATA_TOOLS_BASE_PATH, title: 'Overview' },
      ...DATA_TOOLS_SECTIONS.map(section => ({
        to: `${DATA_TOOLS_BASE_PATH}/${section.slug}`,
        title: section.title,
      })),
    ],
  },
  {
    to: '/admin/people',
    title: 'My People',
    icon: <UserPlus size={20} color="white" className="sidebar-menu-icon" />,
  },
];
